<script setup>
import checkAnimation from "@/assets/images/check-animation.gif";
</script>
<script>
import LazyImage from "@/components/atoms/lazy-image";

export default {
  name: "PanierToListeForm",
  components: {
    LazyImage
  },
  props: {
    titre: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>

<template>
  <div>
    <div class="u-text-center">
      <LazyImage
        :src="checkAnimation"
        alt=""
        width="64"
        height="64"
        class="u-inline-block u-mb-sm"
      />
    </div>
    <p class="u-font-15 u-text-center u-mb-lg">
      Vos produits ont bien été enregistrés dans votre liste « {{ titre }} »
    </p>
  </div>
</template>
